import { Action } from '@ngrx/store';
import {
  PaypalAccessToken,
  PaymentsenseToken,
  TrustPaymentsRequestJSON,
  TrustPaymentsPaymentInfo,
  JCCRequestJSON,
  JCCPaymentInfo,
  OrderPaymentInfo,
} from '../payment.types';
import { PaymentRedirectInfo } from './payment.reducer';
import { InitiateOrderPaymentResponse } from '../../store/types/OrderPayment';
import { Event } from 'src/app/stores/event';
import {
  IntegrationInitiatePaymentResponse,
  ReferenceType,
} from '../../store/types/IntegrationPayment';
export enum PaymentActionType {
  ObtainToken = '[paypal] ObtainToken',
  ObtainTokenSuccess = '[paypal] ObtainTokenSuccess',
  ObtainTokenFailed = '[paypal] ObtainTokenFailed',
  CreatePaypalOrder = '[paypal] CreatePaypalOrder',
  CreatePaypalOrderSuccess = '[paypal] ObtainPartnerLinksSuccess',
  CreatePaypalOrderFailed = '[paypal] ObtainPartnerLinksFailed',
  // Square
  CheckoutSquare = '[Square] CheckoutSquare',
  CheckoutSquareSuccess = '[Square] CheckoutSquareSuccess',
  CheckoutSquareFailed = '[Square] CheckoutSquareFailed',
  CompleteSquarePayment = '[Square] CompleteSquarePayment',
  CompleteSquarePaymentSuccess = '[Square] CompleteSquarePaymentSuccess',
  CompleteSquarePaymentFailed = '[Square] CompleteSquarePaymentFailed',
  ClearSquarePayment = '[Square] ClearSquarePayment',
  // VIVA
  ClearVivaPayment = '[Viva] ClearVivaPayment',
  CompleteVivaPayment = '[Viva] CompleteVivaPayment',
  CompleteVivaPaymentSuccess = '[Viva] CompleteVivaPaymentSuccess',
  CompleteVivaPaymentFailed = '[Viva] CompleteVivaPaymentFailed',
  // Paymentsense
  CreatePaymentsenseToken = '[Paymentsense] CreatePaymentsenseToken',
  CreatePaymentsenseTokenSuccess = '[Paymentsense] CreatePaymentsenseTokenSuccess',
  CreatePaymentsenseTokenFailed = '[Paymentsense] CreatePaymentsenseTokenFailed',
  CompletePaymentsensePayment = '[Paymentsense] CompletePaymentsensePayment',
  CompletePaymentsensePaymentSuccess = '[Paymentsense] CompletePaymentsensePaymentSuccess',
  CompletePaymentsensePaymentFailed = '[Paymentsense] CompletePaymentsensePaymentFailed',
  ClearPaymentsense = '[Paymentsense] ClearPaymentsense',

  // TrustPayments
  CreateTrustPaymentsRequestJSON = '[TrustPayments] CreateTrustPaymentsRequestJSON',
  CreateTrustPaymentsRequestJSONSuccess = '[TrustPayments] CreateTrustPaymentsRequestJSONSuccess',
  CreateTrustPaymentsRequestJSONFailed = '[TrustPayments] CreateTrustPaymentsRequestJSONFailed',
  CompleteTrustPaymentsPayment = '[TrustPayments] CompleteTrustPaymentsPayment',
  CompleteTrustPaymentsPaymentSuccess = '[TrustPayments] CompleteTrustPaymentsPaymentSuccess',
  CompleteTrustPaymentsPaymentFailed = '[TrustPayments] CompleteTrustPaymentsPaymentFailed',
  ClearTrustPaymentsPayment = '[TrustPayments] ClearTrustPaymentsPayment',
  // JCC
  CreateJCCRequestJSON = '[JCC] CreateJCCRequestJSON',
  CreateJCCRequestJSONSuccess = '[JCC] CreateJCCRequestJSONSuccess',
  CreateJCCRequestJSONFailed = '[JCC] CreateJCCRequestJSONFailed',
  CompleteJCCPayment = '[JCC] CompleteJCCPayment',
  CompleteJCCPaymentSuccess = '[JCC] CompleteJCCPaymentSuccess',
  CompleteJCCPaymentFailed = '[JCC] CompleteJCCPaymentFailed',
  ClearJCCPayment = '[JCC] ClearJCCPayment',
  SetCustomerInfo = '[stores] SetCustomerInfo',
  ClearCustomerInfo = '[stores] ClearCustomerInfo',
  SetPaymentRedirectInfo = 'SetPaymentRedirectInfo',
  ClearPaymentRedirectInfo = 'ClearPaymentRedirectInfo',
  InitiateVivaPaymentSuccess = '[Viva] InitiateVivaPaymentSuccess',

  // Order Payment
  InitiateOrderPayment = '[orderPaymentState] InitiateOrderPayment',
  InitiateOrderPaymentSuccess = '[orderPaymentState] InitiateOrderPaymentSuccess',
  InitiateOrderPaymentFailed = '[orderPaymentState] InitiateOrderPaymentFailed',

  CompleteOrderPayment = '[orderPaymentState] CompleteOrderPayment',
  CompleteOrderPaymentSuccess = '[orderPaymentState] CompleteOrderPaymentSuccess',
  CompleteOrderPaymentFailed = '[orderPaymentState] CompleteOrderPaymentFailed',
  ClearOrderPayment = '[orderPaymentState] ClearOrderPayment',
  FetchPaymentStatus = '[orderPaymentState] FetchPaymentStatus',

  setGlobalPayRequestJson = '[globalPayState] setGlobalPayRequestJson',
  setGlobalPayRequestJsonSuccess = '[globalPayState] setGlobalPayRequestJsonSuccess',

  setNbgPayRequestJson = '[nbgPayState] setNbgPayRequestJson',
  setNbgPayRequestJsonSuccess = '[nbgPayState] setNbgPayRequestJsonSuccess',

  redirectPaymentProviderPage = '[realexPaymentState] redirectPaymentProviderPage',
  redirectPaymentProviderPageSuccess = '[realexPaymentState] redirectPaymentProviderPageSuccess',

  setRmsRequestJson = '[rmsState] setRmsRequestJson',
  setRmsRequestJsonSuccess = '[rmsState] setRmsRequestJsonSuccess',

  CompletePayment = '[paymentState] CompletePayment',
  CompletePaymentSuccess = '[paymentState] CompletePaymentSuccess',
  CompletePaymentFailed = '[paymentState] CompletePaymentFailed',

  IntegrationInitiatePayment = '[integrationPaymentState] IntegrationInitiatePayment',
  IntegrationInitiatePaymentSuccess = '[integrationPaymentState] IntegrationInitiatePaymentSuccess',
  IntegrationInitiatePaymentFailed = '[integrationPaymentState] IntegrationInitiatePaymentFailed',
  IntegrationPaymentInProgress = '[integrationPaymentState] IntegrationPaymentInProgress',

  IntegrationCompletePayment = '[integrationPaymentState] IntegrationCompletePayment',
  IntegrationCompletePaymentSuccess = '[integrationPaymentState] IntegrationCompletePaymentSuccess',
  IntegrationCompletePaymentFailed = '[integrationPaymentState] IntegrationCompletePaymentFailed',

  IntegrationPaymentNavigation = '[integrationPaymentState] IntegrationPaymentNavigation',
  FetchIntegrationPaymentStatus = '[integrationPaymentState] FetchIntegrationPaymentStatus',
  ClearIntegrationPayment = '[integrationPaymentState] ClearIntegrationPayment',

  PaymentMessageDialogFailed = '[paymentMessageDialogState] PaymentMessageDialogFailed',
  ClearPaymentMessageDialog = '[paymentMessageDialogState] ClearPaymentMessageDialog',
}

/**
 * @deprecated - unused, no references in the project
 */
export class ObtainToken implements Action {
  readonly type = PaymentActionType.ObtainToken;

  constructor() {}
}

/**
 * @deprecated - parent ObtainToken is deprecated
 */
export class ObtainTokenSuccess implements Action {
  readonly type = PaymentActionType.ObtainTokenSuccess;

  constructor(public readonly tokenData: PaypalAccessToken) {}
}

/**
 * @deprecated - parent ObtainToken is deprecated
 */
export class ObtainTokenFailed implements Action {
  readonly type = PaymentActionType.ObtainTokenFailed;

  constructor() {}
}

/**
 * @todo - incomplete development
 */
export class CreatePaypalOrder implements Action {
  readonly type = PaymentActionType.CreatePaypalOrder;

  constructor(
    public readonly paypalConfigObject: {},
    public readonly accessToken: string,
  ) {}
}

/**
 * @todo - incomplete development
 */
export class CreatePaypalOrderSuccess implements Action {
  readonly type = PaymentActionType.CreatePaypalOrderSuccess;

  constructor(public readonly linksData: any) {}
}

/**
 * @todo - incomplete development
 */
export class CreatePaypalOrderFailed implements Action {
  readonly type = PaymentActionType.CreatePaypalOrderFailed;

  constructor() {}
}

// STRIPE

/**
 * @deprecated - not used
 */
export class CheckoutSquare implements Action {
  readonly type = PaymentActionType.CheckoutSquare;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly redirectUrl: string,
  ) {}
}

/**
 * @deprecated - not used
 */
export class CheckoutSquareSuccess implements Action {
  readonly type = PaymentActionType.CheckoutSquareSuccess;

  constructor(public readonly squareSessionUrl: string) {}
}

/**
 * @deprecated - not used
 */
export class CheckoutSquareFailed implements Action {
  readonly type = PaymentActionType.CheckoutSquareFailed;

  constructor(public readonly errorMessage: any) {}
}

/**
 * @deprecated - not used
 */
export class CompleteSquarePayment implements Action {
  readonly type = PaymentActionType.CompleteSquarePayment;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
  ) {}
}

/**
 * @deprecated - not used
 */
export class CompleteSquarePaymentSuccess implements Action {
  readonly type = PaymentActionType.CompleteSquarePaymentSuccess;

  constructor() {}
}

/**
 * @deprecated - not used
 */
export class CompleteSquarePaymentFailed implements Action {
  readonly type = PaymentActionType.CompleteSquarePaymentFailed;

  constructor(public readonly errorMessage: any) {}
}

/**
 * @deprecated - not used
 */
export class ClearSquarePayment implements Action {
  readonly type = PaymentActionType.ClearSquarePayment;

  constructor() {}
}

// Viva
/**
 * @deprecated - this action clears the completePaymentState,
 * but that state is not even used selected in the application
 */
export class ClearVivaPayment implements Action {
  readonly type = PaymentActionType.ClearVivaPayment;

  constructor() {}
}

/** @deprecated - use IntegrationCompletePayment instead */
export class CompleteVivaPayment implements Action {
  readonly type = PaymentActionType.CompleteVivaPayment;
  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly orderCode: number,
    public readonly eventId: number,
    public readonly eci: number,
    public readonly aliasName: string,
    public readonly transId?: string,
    public readonly redirectUrl?: string,
    public readonly redirectThankyouUrl?: string,
    public readonly isStandaloneOrder?: boolean,
  ) {}
}
// Paymentsense

/**
 * @deprecated - not used
 */
export class CreatePaymentsenseToken implements Action {
  readonly type = PaymentActionType.CreatePaymentsenseToken;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
  ) {}
}

/**
 * @deprecated - parent CreatePaymentsenseToken deprecated
 */
export class CreatePaymentsenseTokenSuccess implements Action {
  readonly type = PaymentActionType.CreatePaymentsenseTokenSuccess;

  constructor(public readonly token: PaymentsenseToken) {}
}

/**
 * @deprecated - parent CreatePaymentsenseToken deprecated
 */
export class CreatePaymentsenseTokenFailed implements Action {
  readonly type = PaymentActionType.CreatePaymentsenseTokenFailed;

  constructor() {}
}

/**
 * @deprecated - not used
 */
export class ClearPaymentsense implements Action {
  readonly type = PaymentActionType.ClearPaymentsense;

  constructor() {}
}

/**
 * @deprecated - not used
 */
export class CompletePaymentsensePayment implements Action {
  readonly type = PaymentActionType.CompletePaymentsensePayment;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
  ) {}
}

/**
 * @deprecated - parent CompletePaymentsensePayment deprecated
 */
export class CompletePaymentsensePaymentSuccess implements Action {
  readonly type = PaymentActionType.CompletePaymentsensePaymentSuccess;

  constructor() {}
}

/**
 * @deprecated - parent CompletePaymentsensePayment deprecated
 */
export class CompletePaymentsensePaymentFailed implements Action {
  readonly type = PaymentActionType.CompletePaymentsensePaymentFailed;

  constructor() {}
}

// TrustPayments

/**
 * @deprecated - not used
 */
export class CreateTrustPaymentsRequestJSON implements Action {
  readonly type = PaymentActionType.CreateTrustPaymentsRequestJSON;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
  ) {}
}

/**
 * @deprecated - parent CreateTrustPaymentsRequestJSON is deprecated
 */
export class CreateTrustPaymentsRequestJSONSuccess implements Action {
  readonly type = PaymentActionType.CreateTrustPaymentsRequestJSONSuccess;

  constructor(public readonly token: TrustPaymentsRequestJSON) {}
}

/**
 * @deprecated - parent CreateTrustPaymentsRequestJSON is deprecated
 */
export class CreateTrustPaymentsRequestJSONFailed implements Action {
  readonly type = PaymentActionType.CreateTrustPaymentsRequestJSONFailed;

  constructor() {}
}

/**
 * @deprecated - not used
 */
export class ClearTrustPaymentsPayment implements Action {
  readonly type = PaymentActionType.ClearTrustPaymentsPayment;

  constructor() {}
}

/**
 * @deprecated - Need to check the logic
 */
export class CompleteTrustPaymentsPayment implements Action {
  readonly type = PaymentActionType.CompleteTrustPaymentsPayment;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly paymentInfo: TrustPaymentsPaymentInfo,
  ) {}
}

/**
 * @deprecated - not used
 */
export class CompleteTrustPaymentsPaymentSuccess implements Action {
  readonly type = PaymentActionType.CompleteTrustPaymentsPaymentSuccess;

  constructor() {}
}

/**
 * @deprecated - parent CompleteTrustPaymentsPayment deprecated
 */
export class CompleteTrustPaymentsPaymentFailed implements Action {
  readonly type = PaymentActionType.CompleteTrustPaymentsPaymentFailed;

  constructor() {}
}

/**
 * @deprecated - unused, will be removed in the later stage
 */
export class CreateJCCRequestJSON implements Action {
  readonly type = PaymentActionType.CreateJCCRequestJSON;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
  ) {}
}

/**
 * @deprecated - unused except the deprecated CreateJCCRequestJSON, will be removed in the later stage
 */
export class CreateJCCRequestJSONSuccess implements Action {
  readonly type = PaymentActionType.CreateJCCRequestJSONSuccess;

  constructor(public readonly token: JCCRequestJSON) {}
}

/**
 * @deprecated - unused except the deprecated CreateJCCRequestJSON, will be removed in the later stage
 */
export class CreateJCCRequestJSONFailed implements Action {
  readonly type = PaymentActionType.CreateJCCRequestJSONFailed;

  constructor() {}
}

/**
 * @deprecated - used alternate IntegrationPayment action,
 * currently found usage in store-checkout-payment.component.ts and marked as deprecated
 * and will be removed in the later stage
 */
export class ClearJCCPayment implements Action {
  readonly type = PaymentActionType.ClearJCCPayment;

  constructor() {}
}

/**
 * @deprecated - unused, will be removed in the later stage
 */
export class CompleteJCCPayment implements Action {
  readonly type = PaymentActionType.CompleteJCCPayment;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly paymentInfo: JCCPaymentInfo,
  ) {}
}

/**
 * @deprecated - unused except the deprecated CompleteJCCPayment, will be removed in the later stage
 */
export class CompleteJCCPaymentSuccess implements Action {
  readonly type = PaymentActionType.CompleteJCCPaymentSuccess;

  constructor() {}
}

/**
 * @deprecated - unused except the deprecated CompleteJCCPayment, will be removed in the later stage
 */
export class CompleteJCCPaymentFailed implements Action {
  readonly type = PaymentActionType.CompleteJCCPaymentFailed;

  constructor() {}
}

/** @deprecated - parent CompleteVivaPayment is deprecated */
export class CompleteVivaPaymentSuccess implements Action {
  readonly type = PaymentActionType.CompleteVivaPaymentSuccess;

  constructor(
    public readonly paymentSuccess = false,
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly aliasName: string,
    public readonly redirectUrl?: string,
    public readonly redirectThankyouUrl?: string,
  ) {}
}

/** @deprecated - not used */
export class CompleteVivaPaymentFailed implements Action {
  readonly type = PaymentActionType.CompleteVivaPaymentFailed;

  constructor() {}
}

export class SetPaymentRedirectInfo implements Action {
  readonly type = PaymentActionType.SetPaymentRedirectInfo;

  constructor(public readonly info: PaymentRedirectInfo) {}
}

export class ClearPaymentRedirectInfo implements Action {
  readonly type = PaymentActionType.ClearPaymentRedirectInfo;

  constructor() {}
}

/**
 * @deprecated - use IntegrationInitiatePayment
 */
// Payment
export class InitiateOrderPayment implements Action {
  readonly type = PaymentActionType.InitiateOrderPayment;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly originType?: string,
    public readonly originDomain?: string,
    public readonly paymentMethod?: string,
    public readonly subPaymentMethod?: string,
  ) {}
}

/**
 * @deprecated - use IntegrationInitiatePayment
 */
export class InitiateOrderPaymentSuccess implements Action {
  readonly type = PaymentActionType.InitiateOrderPaymentSuccess;

  constructor(
    public readonly initiateOrderPaymentResponse: InitiateOrderPaymentResponse,
  ) {}
}

/**
 * @deprecated - use IntegrationInitiatePayment
 */
export class InitiateOrderPaymentFailed implements Action {
  readonly type = PaymentActionType.InitiateOrderPaymentFailed;

  constructor() {}
}

/**
 * @deprecated - method is not referenced
 */
export class CompleteOrderPayment implements Action {
  readonly type = PaymentActionType.CompleteOrderPayment;

  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly orderPaymentInfo: OrderPaymentInfo,
  ) {}
}

/**
 * @deprecated - use IntegrationCompletePaymentSuccess instead
 */
export class CompleteOrderPaymentSuccess implements Action {
  readonly type = PaymentActionType.CompleteOrderPaymentSuccess;

  constructor(public readonly order: any) {}
}

/**
 * @deprecated - use IntegrationCompletePaymentFailed instead
 */
export class CompleteOrderPaymentFailed implements Action {
  readonly type = PaymentActionType.CompleteOrderPaymentFailed;

  constructor(public readonly order: any) {}
}

export class IntegrationInitiatePayment implements Action {
  readonly type = PaymentActionType.IntegrationInitiatePayment;

  constructor(
    public readonly referenceType: ReferenceType,
    public readonly storeId: number,
    public readonly referenceId: string,
    public readonly originType?: string,
    public readonly originDomain?: string,
    public readonly paymentMethod?: string,
    public readonly subPaymentMethod?: string,
    public readonly customerName?: string,
  ) {}
}

export class IntegrationInitiatePaymentSuccess implements Action {
  readonly type = PaymentActionType.IntegrationInitiatePaymentSuccess;

  constructor(
    public readonly integrationInitiatePaymentResponse: IntegrationInitiatePaymentResponse,
  ) {}
}

export class IntegrationInitiatePaymentFailed implements Action {
  readonly type = PaymentActionType.IntegrationInitiatePaymentFailed;

  constructor() {}
}

export class FetchIntegrationPaymentStatus implements Action {
  readonly type = PaymentActionType.FetchIntegrationPaymentStatus;
  constructor(
    public readonly storeId: number,
    public readonly paymentId: string,
  ) {}
}

export class IntegrationPaymentInProgress implements Action {
  readonly type = PaymentActionType.IntegrationPaymentInProgress;
  constructor() {}
}

export class IntegrationCompletePayment implements Action {
  readonly type = PaymentActionType.IntegrationCompletePayment;

  constructor(
    public readonly storeId: number,
    public readonly paymentTransactionId: string,
    public readonly data: any,
  ) {}
}

export class IntegrationCompletePaymentSuccess implements Action {
  readonly type = PaymentActionType.IntegrationCompletePaymentSuccess;

  constructor(public readonly payment: any) {}
}

export class IntegrationCompletePaymentFailed implements Action {
  readonly type = PaymentActionType.IntegrationCompletePaymentFailed;

  constructor(public readonly payment: any) {}
}

export class IntegrationPaymentNavigation implements Action {
  readonly type = PaymentActionType.IntegrationPaymentNavigation;

  constructor(public readonly navigationUrl: any) {}
}

export class ClearIntegrationPayment implements Action {
  readonly type = PaymentActionType.ClearIntegrationPayment;
  constructor(public readonly event?: Event) {}
}

/**
 * @deprecated - use ClearIntegrationPayment instead
 */
export class ClearOrderPayment implements Action {
  readonly type = PaymentActionType.ClearOrderPayment;

  constructor(public readonly event?: Event) {}
}

/** @deprecated - use fetchIntegrationPaymentStatus instead */
export class FetchPaymentStatus implements Action {
  readonly type = PaymentActionType.FetchPaymentStatus;
  constructor(
    public readonly storeId: number,
    public readonly paymentId: string,
    public readonly isStandalonePayment: boolean,
  ) {}
}

export class SetGlobalPayRequestJson implements Action {
  readonly type = PaymentActionType.setGlobalPayRequestJson;
  constructor(public readonly requestJSON: any) {}
}
export class SetGlobalPayRequestJsonSuccess implements Action {
  readonly type = PaymentActionType.setGlobalPayRequestJsonSuccess;
  constructor() {}
}

export class SetNbgPayRequestJson implements Action {
  readonly type = PaymentActionType.setNbgPayRequestJson;
  constructor(public readonly requestJSON: any) {}
}
export class SetNbgPayRequestJsonSuccess implements Action {
  readonly type = PaymentActionType.setNbgPayRequestJsonSuccess;
  constructor() {}
}

export class SetRmsRequestJson implements Action {
  readonly type = PaymentActionType.setRmsRequestJson;
  constructor(public readonly requestJSON: any) {}
}
export class SetRmsRequestJsonSuccess implements Action {
  readonly type = PaymentActionType.setRmsRequestJsonSuccess;
  constructor() {}
}

export class RedirectPaymentProviderPage implements Action {
  readonly type = PaymentActionType.redirectPaymentProviderPage;
  constructor(
    public readonly hppUrl: string,
    public readonly responseUrl: string,
    public readonly jsonFromRequestEndpoint: any,
  ) {}
}

export class RedirectPaymentProviderPageSuccess implements Action {
  readonly type = PaymentActionType.redirectPaymentProviderPageSuccess;
  constructor() {}
}

export class PaymentMessageDialogFailed implements Action {
  readonly type = PaymentActionType.PaymentMessageDialogFailed;
  constructor(
    public readonly errors: any[],
    public readonly title?: string,
  ) {}
}

export class ClearPaymentMessageDialog implements Action {
  readonly type = PaymentActionType.ClearPaymentMessageDialog;
  constructor() {}
}

/**
 * @deprecated - use IntegrationCompletePayment instead
 */
export class CompletePayment implements Action {
  readonly type = PaymentActionType.CompletePayment;
  constructor(
    public readonly storeId: number,
    public readonly orderUuid: string,
    public readonly paymentProviderResponse: any,
    public readonly isStandaloneOrder: boolean,
    public readonly redirectUrl: string,
  ) {}
}

/**
 * @deprecated - use IntegrationCompletePaymentSuccess instead
 */
export class CompletePaymentSuccess implements Action {
  readonly type = PaymentActionType.CompletePaymentSuccess;
  constructor(public readonly redirectThankyouUrl: string) {}
}

/**
 * @deprecated - use IntegrationCompletePaymentFailed instead
 */
export class CompletePaymentFailed implements Action {
  readonly type = PaymentActionType.CompletePaymentFailed;
  constructor() {}
}

export type PaymentStoresAction =
  | ObtainToken
  | ObtainTokenSuccess
  | ObtainTokenFailed
  | CreatePaypalOrder
  | CreatePaypalOrderSuccess
  | CreatePaypalOrderFailed
  // STRIPE
  // Square
  | CheckoutSquare
  | CheckoutSquareSuccess
  | CheckoutSquareFailed
  | CompleteSquarePayment
  | CompleteSquarePaymentSuccess
  | CompleteSquarePaymentFailed
  | ClearSquarePayment
  // Viva
  | ClearVivaPayment
  | CompleteVivaPayment
  | CompleteVivaPaymentSuccess
  | CompleteVivaPaymentFailed
  // Paymentsense
  | CreatePaymentsenseToken
  | CreatePaymentsenseTokenSuccess
  | CreatePaymentsenseTokenFailed
  | ClearPaymentsense
  | CompletePaymentsensePayment
  | CompletePaymentsensePaymentSuccess
  | CompletePaymentsensePaymentFailed
  // TrustPayments
  | CreateTrustPaymentsRequestJSON
  | CreateTrustPaymentsRequestJSONSuccess
  | CreateTrustPaymentsRequestJSONFailed
  | ClearTrustPaymentsPayment
  | CompleteTrustPaymentsPayment
  | CompleteTrustPaymentsPaymentSuccess
  | CompleteTrustPaymentsPaymentFailed
  // JCC
  | CreateJCCRequestJSON
  | CreateJCCRequestJSONSuccess
  | CreateJCCRequestJSONFailed
  | ClearJCCPayment
  | CompleteJCCPayment
  | CompleteJCCPaymentSuccess
  | CompleteJCCPaymentFailed
  | SetPaymentRedirectInfo
  | ClearPaymentRedirectInfo
  // Order Payment
  | InitiateOrderPayment
  | InitiateOrderPaymentSuccess
  | InitiateOrderPaymentFailed
  | CompleteOrderPayment
  | CompleteOrderPaymentSuccess
  | CompleteOrderPaymentFailed
  | ClearOrderPayment
  | FetchPaymentStatus
  | SetGlobalPayRequestJson
  | SetGlobalPayRequestJsonSuccess
  | SetNbgPayRequestJson
  | SetNbgPayRequestJsonSuccess
  | SetRmsRequestJson
  | SetRmsRequestJsonSuccess
  | RedirectPaymentProviderPage
  | RedirectPaymentProviderPageSuccess
  | CompletePayment
  | CompletePaymentSuccess
  | CompletePaymentFailed
  | IntegrationInitiatePayment
  | IntegrationInitiatePaymentSuccess
  | IntegrationInitiatePaymentFailed
  | IntegrationPaymentInProgress
  | IntegrationCompletePayment
  | IntegrationCompletePaymentSuccess
  | IntegrationCompletePaymentFailed
  | IntegrationPaymentNavigation
  | FetchIntegrationPaymentStatus
  | ClearIntegrationPayment
  | PaymentMessageDialogFailed
  | ClearPaymentMessageDialog;
